module.exports = __webpack_public_path__ + "static/circles-0ecb70c3e07ec5c22f8db5b672198d0c.png";